<template lang="pug">
    v-row(v-if="favorites.length > 0")
        v-col(cols="12" md="4" v-for="(favorite, index) in favorites")
            v-card.mx-auto(max-width="344" @click="goToShop(favorite)")
                v-img(:src='getImage(favorite.image)' height="200px")
                v-list-item
                  v-list-item-icon(@click="removeFavorite(favorite)").mr-0
                    v-icon(color="red") mdi-heart
                  v-list-item-subtitle
                    h3 {{favorite.name}}
                v-list-item
                  v-list-item-icon(@click="removeFavorite(favorite)").mr-0
                    v-icon mdi-map-marker
                  v-list-item-subtitle
                    h3 {{favorite.addressgoogle}}
    v-row(v-else)
        NoResults(title="Aún no tienes lugares favoritos", description="En esta sección encontraras tus favoritos")
</template>

<script>
  import shopPlaceHolder from '@/assets/icons/shop.svg'
  export default {

    components: {
      NoResults: () => import('@/components/custom/NoResults'),
      shopPlaceHolder: shopPlaceHolder,
    },

    data () {
      return {}
    },

    computed: {
      favorites () {
        return this.$store.getters['shops/getFavorites']
      },
    },

    methods: {
      removeFavorite (favorite) {
        // console.log(favorite)
        const vm = this
        vm.$store.dispatch('shops/removeFavorites', favorite).then(() => {
          // console.log('remove')
        })
      },
      getImage (item) {
        // console.log(item)
        if (item) {
          return item
        } else {
          return shopPlaceHolder
        }
      },
      goToShop (favorite) {
        this.$router.push(`/shop/${favorite.id}`)
      },
    },
  }
</script>
